import controller from './mf-values.controller';
import template from './mf-values.html';

export default {
	template,
	bindings: {
		disabled: '<?ngDisabled',
		filter:   '<?',
		onDelete: '&?',
		readOnly: '<?',
		values:   '=ngModel',
	},
	controller,
	require:  {
		parent: '^^?mf',
	},
};
